/**
 * @desc handleBatchData
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(params: API.fulfilment.test.handleBatchData.Params, options?: any) {
  return updateResponse(
    http(URL + `/test/handleBatchData`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
